import { components } from 'admin/schema/docs/api/admin';

type Customer = components['schemas']['Customer'];

const convertAccountStatusToJapanese = (accountStatus?: Customer['account_status']) => {
  switch (accountStatus) {
    case 'active':
      return '有効';
    case 'suspended':
      return '凍結中';
    case 'pre-closed':
      return '退会準備中';
    case 'closed':
      return '退会済';
    default:
      return '状態不明';
  }
};

export default convertAccountStatusToJapanese;
